import * as React from "react";

function SvgStarCircleIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 194 194" {...props}><path d="M96.9 2c-52.4 0-95 42.6-95 95s42.6 95 95 95 95-42.6 95-95-42.6-95-95-95zm37.8 150.1l-37.8-19.5-37.8 19.5 6.9-41.9-30.2-29.9 42-6.4 19.1-38 19.1 38 42 6.4-30.2 29.9 6.9 41.9z" /></svg>;
}

export default SvgStarCircleIcon;